import React from 'react';
import PropTypes from 'prop-types';
import { Media } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { faSignalStream } from '@fortawesome/pro-solid-svg-icons';
import InlineConfirmation from 'components/InlineComfirmations/InlineComfirmation';
import {
  StyledListGroupItem,
  NotificationWrapper,
  NotificationText,
  StyledStreamIcon
} from './ActiveStream.styled';

import { StyledModalCancelButton } from 'components/Modal/Button.styled';

export const Notification = () => {
  return (
    <NotificationWrapper>
      <FontAwesomeIcon data-testid="notification-icon" icon={faCheckCircle} />
      <NotificationText>Stream stopped!</NotificationText>
    </NotificationWrapper>
  );
};
const ActiveStreamListItems = ({
  stream = {},
  showStopStreamConfirmation,
  handleStopStream,
  handleConfirmation,
  isStreamStopped
}) => {
  const streamIcon = require(`./${
    stream && stream.s3Key ? 'record' : 'istreams'
  }.svg`);

  const renderStreamIcon = () => {
    if (stream && stream.taskId && !stream.s3Key) {
      return (
        <StyledStreamIcon>
          <FontAwesomeIcon className="icon" icon={faSignalStream} />
        </StyledStreamIcon>
      );
    }

    return (
      <Media object src={streamIcon} alt={`${stream && stream.title}-icon`} />
    );
  };
  const displayActions = () => {
    const streamIsStopped = isStreamStopped && isStreamStopped(stream);
    if (streamIsStopped) return <Notification />;

    return (
      <StyledModalCancelButton
        data-testid={stream._id}
        onClick={() => handleConfirmation(stream._id, true)}
        outline
      >
        Stop stream
      </StyledModalCancelButton>
    );
  };

  return (
    <StyledListGroupItem>
      <Media>
        <Media left middle>
          {renderStreamIcon()}
        </Media>
        <Media body middle>
          {stream && stream.title}
        </Media>
      </Media>

      {showStopStreamConfirmation && showStopStreamConfirmation[stream._id] ? (
        <InlineConfirmation
          onConfirm={() => {
            handleStopStream(stream);
            handleConfirmation(stream._id, false);
          }}
          onCancel={() => {
            handleConfirmation(stream._id, false);
          }}
        />
      ) : (
        displayActions()
      )}
    </StyledListGroupItem>
  );
};

ActiveStreamListItems.propTypes = {
  stream: PropTypes.object,
  showStopStreamConfirmation: PropTypes.object,
  handleStopStream: PropTypes.func,
  handleConfirmation: PropTypes.func,
  isStreamStopped: PropTypes.func
};

export default ActiveStreamListItems;
